'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaXingSquare = function FaXingSquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.3 17.1q0 0-2.8-5-0.5-0.7-1.2-0.7h-4.1q-0.4 0-0.6 0.2-0.1 0.3 0 0.7l2.8 4.8v0l-4.3 7.7q-0.2 0.3 0 0.6 0.1 0.3 0.5 0.3h4.1q0.7 0 1.1-0.8z m13.9-11.1q-0.1-0.3-0.5-0.3h-4.2q-0.7 0-1.1 0.8l-9.2 16.3q0.1 0 5.9 10.7 0.4 0.8 1.2 0.8h4.1q0.4 0 0.5-0.3 0.2-0.3 0-0.6l-5.8-10.6v-0.1l9.1-16.1q0.2-0.4 0-0.6z m5.1 3.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaXingSquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/xing-square.js
// module id = 657
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464